import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getGenreCount } from '@/utils/movies';

export default function CategoryQuickNav() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950 md:text-lg">
            <i className="ri-layout-grid-line text-accent-500"></i>
            分类快捷入口
          </h2>
          <Link
            to="/category"
            className="flex items-center gap-1 text-sm font-medium text-foreground-600 transition hover:text-accent-700"
          >
            全部分类
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-6">
          {categories.map((category, i) => (
            <Link
              key={category.slug}
              to={`/category?genre=${encodeURIComponent(category.slug)}`}
              className={`group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-2 py-4 text-center transition hover:-translate-y-1 hover:border-accent-400/70 anim-fade-up delay-${(i % 5) + 1}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100/25 text-secondary-900 transition group-hover:bg-accent-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-900">{category.name}</span>
              <span className="text-[11px] text-foreground-500">{getGenreCount(category.slug)} 部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}